import { getToken } from "services/auth/tokenAuth";
import doRequest from "services/helpers";
import { onlyAllowedCampusSpaces } from "./constants";

export const requestGetResourceModules = async () => {
    const [result, err] = await doRequest(
        "/Recurso/ListarEspacios", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.espacios
        .filter(({ idEspacio }) => onlyAllowedCampusSpaces(idEspacio))
        .map(({
            idEspacio, nombre
        }) => ({
            id: idEspacio,
            name: nombre
        }));
}
export const requestGetSpacesMinified = async ({
    campusId, spaceTypeId
}) => {
    const [result, err] = await doRequest(
        "/Recurso/ListarNombreEspacioPolideportivo", "POST", 
        {
            idCampus: campusId,
            idTipoPolideportivo: spaceTypeId
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.espaciosPolideportivo
        .map(({ 
            idPolideportivo, 
            nombreEspacioPolideportivo 
        }) => ({
            id: idPolideportivo,
            name: nombreEspacioPolideportivo
        }));
}